var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 13.5H11.0833V10C11.0833 9.75 10.8333 9.5 10.5833 9.5H3.58331C3.30206 9.5 3.08331 9.75 3.08331 10V18C3.08331 18.2812 3.30206 18.5 3.58331 18.5H16.5833C16.8333 18.5 17.0833 18.2812 17.0833 18V14C17.0833 13.75 16.8333 13.5 16.5833 13.5ZM10.0833 17.5H4.08331V14.5H10.0833V17.5ZM10.0833 13.5H4.08331V10.5H10.0833V13.5ZM16.0833 17.5H11.0833V14.5H16.0833V17.5ZM19.1458 6.21875L10.6458 2.625C10.2708 2.46875 9.86456 2.46875 9.48956 2.625L0.989563 6.21875C0.427063 6.4375 0.083313 7 0.083313 7.59375V18.25C0.083313 18.4062 0.177063 18.5 0.333313 18.5H0.833313C0.958313 18.5 1.08331 18.4062 1.08331 18.25V7.59375C1.08331 7.375 1.17706 7.21875 1.36456 7.125L9.86456 3.5625C9.98956 3.5 10.1458 3.5 10.2708 3.5625L18.7708 7.125C18.9583 7.21875 19.0833 7.375 19.0833 7.59375V18.25C19.0833 18.4062 19.1771 18.5 19.3333 18.5H19.8333C19.9583 18.5 20.0833 18.4062 20.0833 18.25V7.59375C20.0833 7 19.7083 6.4375 19.1458 6.21875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockStates);
export default __webpack_public_path__ + "static/media/stock-states.7d9e9d49.svg";
export { ForwardRef as ReactComponent };